import { Radii, Spacing } from '~/types/ThemeTypes'
import { createMultiStyleConfigHelpers } from '~/utils/chakraUtils'

const tagStyleParts = ['container', 'label', 'closeButton'] as const

const helpers = createMultiStyleConfigHelpers(tagStyleParts)
export enum TagVariant {
  TagInput = 'tagInput',
  Subtle = 'subtle',
  Solid = 'solid',
  Outline = 'border.default',
}
export const TagStyle = helpers.defineMultiStyleConfig({
  variants: {
    [TagVariant.TagInput]: {
      container: {
        height: Spacing._6,
        padding: Spacing._2,
        borderRadius: Radii._3xl,
        bg: 'bg.emphasized',
        color: 'fg.default',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
})
